import Backbone from 'backbone'
import BaseModel from 'models/base'
import CreditUsage from 'models/credit_usage'
import { compact } from 'underscore'
import { pluralize } from 'utils/common'

export default class Subscription extends BaseModel {
  url () {
    if (this.id) {
      return `/subscriptions/${this.id}`
    } else {
      return '/subscriptions'
    }
  }

  usageLabel () {
    return compact([
      (this.get('cancel_at_period_end') && 'cancels at end of period') || null,
      (this.get('refunded') && 'refunded') || null,
      this.guidesShownLabel(),
      this.creditsLeftLabel(),
    ]).join(' &bullet; ')
  }

  creditsLeftLabel () {
    const creditsLeft = this.get('credits_available')

    return this.get('subscription_type') === 'OfficeHours' &&
      creditsLeft != null
      ? `${creditsLeft} ${pluralize('credit', creditsLeft)} left`
      : null
  }

  guidesShownLabel () {
    const guidesShown = this.get('num_reveals')

    return this.get('subscription_type') === 'OfficeHours' &&
      !this.get('canceled')
      ? `${guidesShown} ${pluralize('guide', guidesShown)} shown`
      : null
  }

  parse (resp, options) {
    super.parse(resp, options)
    this.currentUsage = this.hasOne('current_usage', CreditUsage, resp)
    this.paymentIntent = this.hasOne('payment_intent', Backbone.Model, resp)
    return resp
  }

  requiresAction () {
    return (
      this.paymentIntent?.get('status') === 'requires_action' ||
      this.paymentIntent?.get('status') === 'requires_payment_method'
    )
  }

  inTrialPeriod () {
    return this.get('status') === 'trialing'
  }

  isActive () {
    return this.get('status') === 'active' || this.get('status') === 'trialing'
  }

  renewalVerb () {
    if (this.get('cancel_at_period_end')) {
      return 'end'
    } else {
      return 'renew'
    }
  }

  cancel ({ immediate = false, refund = false, callback = null }) {
    this.command(`${this.url()}/cancel`, {
      method: 'POST',
      data: { immediate, refund },
      success: (model, resp) => {
        this.set(resp, { parse: true })
        callback?.()
      },
    })
  }
}
